import ImageUpload from './ImageUpload';

export default ImageUpload;
